import React from 'react';
import { Row, Col, Card, Select } from 'antd';
import SegmentsTable from './SegmentsTable';
import SegmentsRingChart from './SegmentsRingChart';
// Global Styling
import {
  CardTitleText,
  MenuItemText,
  TableColumnTitle,
} from '../../../../../shared/globalStyling/styledText';
//colors
import { colors } from '../../../../../../core/utils/constants/listOfColors';

const { Option } = Select;
const Style = {
  campaignCardStyle: {
    margin: 5,
    padding: 2,
    height: 340,
    backgroundColor: '#fff',
  },
  campaignCardStyleCreatives: {
    backgroundColor: '#fff',
  },
  keyColors: {
    spent: '#1665d8',
    remaining: '#34aa44',
    budget: '#030303',
    total: '#bec0c3',
    value: '#99999',
  },
  title: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'flex-start',
    alignItems: 'center',
  },
  xs: {
    span: 24,
    offset: 0,
  },
  sm: {
    span: 24,
    offset: 0,
  },
  md: {
    span: 16,
    offset: 0,
  },
  lg: {
    span: 16,
    offset: 0,
  },
  xl: {
    span: 16,
    offset: 0,
  },
  xsPie: {
    span: 24,
    offset: 0,
  },
  smPie: {
    span: 24,
    offset: 0,
  },
  mdPie: {
    span: 8,
    offset: 0,
  },
  lgPie: {
    span: 8,
    offset: 0,
  },
  xlPie: {
    span: 8,
    offset: 0,
  },
};

const {
  xs,
  sm,
  md,
  lg,
  xl,
  xsPie,
  smPie,
  mdPie,
  lgPie,
  xlPie,
  keyColors,
  campaignCardStyle,
  campaignCardStyleCreatives,
} = Style;

const options = [
  {
    value: 'ais',
    text: 'Ad Impressions',
  },
  {
    value: 'ctr',
    text: 'CTR Percentage',
  },
  {
    value: 'clicks',
    text: 'Clicks',
  },
];

const Extra = ({ setSegmentsDimension }) => {
  return (
    <Row align="bottom">
      <TableColumnTitle text={'Show By:'} />
      <Select
        defaultValue={options[0].value}
        onChange={(value) => {
          setSegmentsDimension(value);
        }}
      >
        {options.map((option, index) => {
          return (
            <Option key={index} value={option.value}>
              <MenuItemText text={option.text} />
            </Option>
          );
        })}
      </Select>
    </Row>
  );
};

const SegmentsDetails = (props) => {
  const { selectedSegmentsDimension, setSegmentsDimension, segmentsData } = props;

  const colorValuePairs = segmentsData.map((el, index) => {
    if (el.retargeting_name) {
      return {
        ...el,
        value: el.retargeting_name,
        color: colors[index],
      };
    } else if (el.value) {
      return {
        ...el,
        color: colors[index],
      };
    }
    return {
      ...el,
      value: `Segments ${index}`,
      color: colors[index],
    };
  });

  return (
    <Row gutter={35}>
      <Col xs={xs} sm={sm} md={md} lg={lg} xl={xl}>
        <Card
          style={campaignCardStyleCreatives}
          headStyle={{ borderWidth: '3px', height: '66px' }}
          bodyStyle={{ padding: 0 }}
          title={<CardTitleText text={'Segments'} />}
        >
          <SegmentsTable segmentsData={colorValuePairs} />
        </Card>
      </Col>
      <Col xs={xsPie} sm={smPie} md={mdPie} lg={lgPie} xl={xlPie}>
        <Card
          style={campaignCardStyleCreatives}
          bodyStyle={{ padding: 0, height: '100%' }}
          headStyle={{ borderWidth: '2px' }}
          title={<CardTitleText text={'Breakdown'} />}
          extra={<Extra setSegmentsDimension={setSegmentsDimension} />}
        >
          <SegmentsRingChart
            data={colorValuePairs}
            keyColors={keyColors}
            height={campaignCardStyle.height}
            selectedSegmentsDimension={selectedSegmentsDimension}
          />
        </Card>
      </Col>
    </Row>
  );
};

export default SegmentsDetails;
